import {createTheme} from '@material-ui/core/styles';

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: '#00BCD4',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: '#FF3344',
    },
    background: {
      default: '#fff',
      drawer: '#263238',
    },
    stemhero: {
      red: '#FF3344',
      darkBlue: '#006DAA',
      blue: '#19CCCC',
      yellow: '#F9FA34',
    },
    meterTypeColor: (meter) => {
      if (meter.type === 'gas') {
        return theme.palette.stemhero.blue;
      } else if (meter.type === 'water') {
        return theme.palette.stemhero.darkBlue;
      } else if (meter.type === 'electric') {
        return theme.palette.stemhero.red;
      } else {
        return 'lightgrey';
      }
    },
    // Text/icon color to use on top of meterTypeColor. White only reaches
    // WCAG AA contrast (4.5:1) on the water blue; the teal, red and grey
    // backgrounds need dark text.
    meterTypeTextColor: (meter) => {
      return meter.type === 'water' ? '#fff' : '#111';
    },
  },
});

export default theme;
